import helpSearchImg from "@/shared/assets/illustrations/help-topics/magnifying-glass.svg";
import helpLegalImg from "@/shared/assets/illustrations/help-topics/balance.svg";
import helpBillsImg from "@/shared/assets/illustrations/help-topics/bill.svg";
import helpInsuranceImg from "@/shared/assets/illustrations/help-topics/success.svg";
import helpIdentityImg from "@/shared/assets/illustrations/help-topics/identity-protection.svg";
import helpExpertImg from "@/shared/assets/illustrations/help-topics/customer-service.svg";

import type { FlowAnswers, FlowScreen } from "@/shared/constants/flowTypes";

export function getHelpTopicsFromAnswers(answers: FlowAnswers): string[] | null {
  const value = answers["help-topics"];
  return Array.isArray(value) ? value : null;
}

export const HELP_TOPICS_SCREEN: FlowScreen = {
  id: "help-topics",
  layout: "full",
  maxWidth: "2xl",
  textAlign: "center",
  showHeaderLogo: true,
  title: "What can we help you with?",
  subtitle: "Let us know where you need help first, and we'll handle the rest as we go.",
  question: {
    id: "help-topics",
    type: "multi_select",
    required: false,
    gridColumns: 3,
    options: [
      {
        value: "search-accounts-assets",
        label: "Search for accounts & assets",
        imageSrc: helpSearchImg,
        bgClass: "bg-salmon-50",
      },
      {
        value: "handle-legal-steps",
        label: "Handle legal steps (with or without a will)",
        imageSrc: helpLegalImg,
        bgClass: "bg-purple-50",
      },
      {
        value: "cancel-bills-subscriptions",
        label: "Cancel bills & subscriptions",
        imageSrc: helpBillsImg,
        bgClass: "bg-blue-50",
      },
      {
        value: "collect-insurance-benefits",
        label: "Collect insurance & benefits",
        imageSrc: helpInsuranceImg,
        bgClass: "bg-blue-50",
      },
      {
        value: "identity-theft-protection",
        label: "Identity theft protection",
        imageSrc: helpIdentityImg,
        bgClass: "bg-yellow-50",
      },
      {
        value: "talk-to-expert",
        label: "Talk to an Elayne Estate Expert",
        imageSrc: helpExpertImg,
        bgClass: "bg-green-50",
      },
    ],
  },
};
